import h from 'hyperscript';

import iconError from '@disy/cadenza-icons/error.svg';
import iconWarning from '@disy/cadenza-icons/warning.svg';
import { icon } from '@disy/ui/icon';

import { getStore } from 'cadenza/store/cadenza-store';
import type { ViewId } from 'cadenza/workbook/api/view-id';
import type {
  DataViewNotification,
  LayerNotification,
  WorkbookNotification,
} from 'cadenza/workbook/notifications/workbook-notifications';
import { replaceNotificationsBySource } from 'cadenza/workbook/workbook.state';

import i18n from './view-notification-util.properties';

export function updateViewNotifications(newViewNotifications: WorkbookNotification[], viewId: ViewId) {
  getStore().dispatch(replaceNotificationsBySource({ viewId, source: 'VIEW', notifications: newViewNotifications }));
}

export function renderNotifications(notifications: WorkbookNotification[]) {
  return h(`.d-stack-v.space-2`, [
    ...notifications.map((notification) =>
      h('d-alert.d-alert-small', {
        attrs: {
          type: notification.level === 'ERROR' ? 'error' : 'warning',
          title: notification.title ?? '',
          message: notification.detail ?? '',
        },
      }),
    ),
  ]);
}

export function updateNotificationsButton(
  notificationsButton: HTMLButtonElement,
  topNotification?: LayerNotification | DataViewNotification,
) {
  notificationsButton.innerHTML = '';
  notificationsButton.classList.remove('button-error', 'button-warning');

  if (topNotification?.level === 'ERROR') {
    notificationsButton.title = i18n('notifications.title.error');
    notificationsButton.classList.add('button-error');
    notificationsButton.append(icon(iconError));
  } else if (topNotification?.level === 'WARNING') {
    notificationsButton.title = i18n('notifications.title.warning');
    notificationsButton.classList.add('button-warning');
    notificationsButton.append(icon(iconWarning));
  }
}
